/**
 * Created by inonstelman on 2/24/15.
 */

Directives.HelpDirective = function HelpDirective() {

    // @ngInject
    var HelpDirectiveControllerFunc = function controller($element, $scope, $injector, UsersManager,
                                                          AppConfigService, IntercomService, UserService, AppStates, DeviceService,
                                                          HelpService, AccountsService, Enums, ClientPortalService) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'HelpDirectiveController';

        this.AppStates = AppStates;
        this.UserService = UserService;
        this.UsersManager = UsersManager;
        this.AppConfigService = AppConfigService;
        this.IntercomService = IntercomService;
        this.DeviceService = DeviceService;
        this.ClientPortalService = ClientPortalService;

        this.UsersManager.on('loggingOut', this._onLoggingOut.bind(this));
        this.UsersManager.on('loggingIn', this._initHelpDirective.bind(this));
        this.UsersManager.on('resetPsw', this._initHelpDirective.bind(this));
        AccountsService.on(Enums.PubSubTriggers.companyChanged, function() {
            IntercomService.identify();
        });
        HelpService.on('showHelp',this.onShowHelp.bind(this));
        HelpService.on('hideHelp',this.onHideHelp.bind(this));

        this._initHelpDirective();
    };

    var HelpDirectiveController = Class(Controllers.BaseController, {
        constructor: HelpDirectiveControllerFunc,

        currUserIsUnsubscribedTrialer: function() {
            return (this.currUser && this.currUser.has_trial && !this.currUser.companyHasSubscription());
        },

        clickScheduleDemo: function clickScheduleDemo() {
            this.UserService.openAECalendlyLink(this.currUser);
        },

        shouldShowIntercom: function shouldShowIntercom() {
            return this.IntercomService.shouldUseIntercom(this.currUser);
        },

        onShowHelp: function onShowHelp() {
            if (this._shouldShowHelp()) {
                this.showHelp = true;
            }
        },

        onHideHelp: function onHideHelp() {
            this.showHelp = false;
        },

        _initHelpDirective: function() {
            this.showHelp = false;
            this.currUser = this.UsersManager.getCurrUser();

            if (this._shouldShowHelp()) {
                this.showHelp = true;
                this._initChat();
            }
        },

        _onLoggingOut: function _onLoggingOut() {
            this.currUser = undefined;
            if (this._shouldShowHelp()) {
                this._shutdownChat();
            }
        },

        _shouldShowHelp: function _shouldShowHelp() {
            return (this.AppConfigService.isProduction() || this.AppConfigService.appConfiguration().enable_help_menu_in_dev);
        },

        _initChat: function _initChat() {
            if (this.shouldShowIntercom()) {
                this.IntercomService.init(this.currUser);
                this.IntercomService.identify();
            }
        },

        _shutdownChat: function _shutdownChat() {
            if (this.shouldShowIntercom()) {
                this.IntercomService.shutdown();
            }
        },
    });
    return {
        scope: {},
        controller: HelpDirectiveController,
        controllerAs: 'helpVm',
        bindToController: true,
        templateUrl: 'angular/app/modules/common/ui_components/help/help_directive_template.html'
    };
};
